// extracted by mini-css-extract-plugin
export default {"vars":"'styles/vars.module.css'","phone":"480px","tablet-max":"1199px","header":"header_header__M7Ol2","logo":"header_logo__vyTVr","logoText":"header_logoText__nywLA"};